export default (axios) => ({
    getAddressList() {
      return axios.get(`/addresses`);
    },
    createAddressItem(payload) {
      return axios.post("/addresses",payload);
    },
    updateAddressItem(id,payload) {
      return axios.put(`/addresses/${id}`, payload);
    },
    deleteAddressItem(id){
      return axios.delete(`/addresses/${id}`);
    },
    setDefault(id){
      return axios.put(`/addresses/${id}/default`);
    }
  });
  